import { Validator } from '@vista-digital/validator';
import { defaultOccAnimationConfig, occAnimationConfigValidator } from './animation';
import { defaultOccFilmConfig, occFilmConfigValidator } from './film';
import { defaultOccFilterConfig, occFilterConfigValidator } from './filter';
import { defaultOccFormConfig, occFormConfigValidator } from './form/form';
import { defaultOccLocaleConfig, occLocaleConfigValidator } from './locale/locale';
import { defaultOccMemberConfig, occMemberConfigValidator } from './member/member';
import { defaultOccNotificationConfig, occNotificationConfigValidator } from './notification';
import { defaultOccSeatingConfig, occSeatingConfigValidator } from './seating/seating';
import { defaultOccSecurityConfig, occSecurityConfigValidator } from './security';
import { defaultOccShowtimeConfig, occShowtimeConfigValidator } from './showtime';
export const defaultOccConfig = {
    animation: defaultOccAnimationConfig,
    enableClearableInputField: false,
    enableSkeletonLoadingIndicators: true,
    film: defaultOccFilmConfig,
    filter: defaultOccFilterConfig,
    form: defaultOccFormConfig,
    locale: defaultOccLocaleConfig,
    member: defaultOccMemberConfig,
    notification: defaultOccNotificationConfig,
    seating: defaultOccSeatingConfig,
    security: defaultOccSecurityConfig,
    showtime: defaultOccShowtimeConfig
};
export const occConfigValidator = Validator.object({
    animation: occAnimationConfigValidator,
    enableClearableInputField: Validator.boolean(),
    enableSkeletonLoadingIndicators: Validator.boolean(),
    film: occFilmConfigValidator,
    filter: occFilterConfigValidator,
    form: occFormConfigValidator,
    locale: occLocaleConfigValidator,
    member: occMemberConfigValidator,
    notification: occNotificationConfigValidator,
    seating: occSeatingConfigValidator,
    security: occSecurityConfigValidator,
    showtime: occShowtimeConfigValidator
});
//# sourceMappingURL=config.js.map